import { render } from "./BuyCoupon.vue?vue&type=template&id=563435b8"
import script from "./BuyCoupon.vue?vue&type=script&lang=js"
export * from "./BuyCoupon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__